import API from "@/api";
import user from "@/store/modules/user";
import store from "@/store";

export default {
  namespaced: true,

  state: {},

  actions: {
    async conversion({}) {
      let { state } = user;
      let { getters } = store;

      try {
        let body = {
          event_type: "CONVERSION",
          event_family: "CDP",
          payload: {
            conversion_identifier: "register",
            name: getters["user/full_name"],
            email: state.user.email,
            state: state.user.profile.state_name,
            city: state.user.profile.city_name,
            mobile_phone: getters["user/phone_number"],
            available_for_mailing: true,
            cf_data_nascimento: getters["user/birthdate"],
            cf_cnpj: getters["user/cnpj"],
            cf_cpf: getters["user/cpf"],
            cf_ddd: getters["user/ddd"]
          }
        };

        await API.RDStation.createEvent(body);
      } catch (e) {
        console.log(e);
      }
    }
  },

  mutations: {},

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/RDStation.js